"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useObservable = void 0;
const react_1 = require("react");
function useObservable(observable) {
    const [value, setValue] = (0, react_1.useState)(observable.currentSync());
    (0, react_1.useEffect)(() => observable.on(setValue), [observable]);
    return value;
}
exports.useObservable = useObservable;
